import _ from 'lodash';
import Cookies from 'universal-cookie';
import CONSTANTS from '../constants';
import OrderHelper from '../helpers/OrderHelper';
import OrderTypeHelper from '../helpers/OrderTypeHelper';
import PaymentHelper from '../helpers/PaymentHelper';
import TimeHelper from '../helpers/TimeHelper';
import LoginService from './LoginService';
import PaymentService from './PaymentService';
const cookies = new Cookies();

export default {
  createOrder,
  getOrders,
  getOrder,
  getMyOrders,
  settleBill,
  billRequestOrders,
  currentTotalOrders,
  updateOrderPayment,
  updateOrder,
  getPOSOrder,
};

async function createOrder(
  userId,
  locationData,
  qrData,
  qrCodeData,
  cartData,
  orderData,
  paymentData = null,
  savyour
) {
  let dateTime = orderData.order_time;
  orderData.order_time = TimeHelper.getUTCTimeString(dateTime);
  orderData.order_date = TimeHelper.getUTCDateString(dateTime);
  let platform = localStorage.getItem('platform');
  let isReward = localStorage.getItem('isRewardOrder');
  orderData.platform = platform === 'app' ? platform : 'web';
  orderData.isRewardOrder = isReward;
  orderData.savyour_order = savyour ? 1 : 0;
  const postData = OrderHelper.makeCreateOrderDto(
    userId,
    qrData,
    qrCodeData,
    cartData,
    orderData,
    paymentData
  );
  const { token } = LoginService.getToken();
  if (paymentData && !_.isEmpty(paymentData)) {
    postData.payment_details = {
      details: JSON.stringify(paymentData),
      method: paymentData.method,
      processor_id: paymentData.processor_id
    };
    postData.payment_status_id = paymentData.payment_status_id;
  } else {
    let paymentStatuses = await PaymentService.getPaymentStatuses();
    let cashPaidStatus = _.find(
      paymentStatuses,
      (paymentStatus) => paymentStatus.key === CONSTANTS.ORDERS.VARIABLES.PAYMENT_STATUSES.NOT_PAID
    );
    let cardPaidStatus = _.find(
      paymentStatuses,
      (paymentStatus) => paymentStatus.key === CONSTANTS.ORDERS.VARIABLES.PAYMENT_STATUSES.PAID
    );
    postData.payment_status_id = cartData.cardPaymentOrder ? cardPaidStatus.id : cashPaidStatus.id;
  }
  let url = `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.ORDERS.CREATE(locationData.slug)}`;
  // let url = `${CONSTANTS.API_URL}${CONSTANTS.URLS.ORDERS.CREATE}`;
  let createdOrder = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(postData),
    headers: { ...CONSTANTS.REQUEST_HEADERS, 'X-ACCESS-TOKEN': token }
  });
  createdOrder = await createdOrder.json();
  if (createdOrder) return createdOrder;
  throw new Error('Could not create order');
}

async function updateOrder(
  orderId,
  userId,
  locationData,
  qrData,
  qrCodeData,
  cartData,
  orderData,
  paymentData = null,
  savyour
) {
  let dateTime = orderData.order_time;
  orderData.order_time = TimeHelper.getUTCTimeString(dateTime);
  orderData.order_date = TimeHelper.getUTCDateString(dateTime);
  let platform = localStorage.getItem('platform');
  orderData.platform = platform === 'app' ? platform : 'web';
  orderData.savyour_order = savyour ? 1 : 0;
  const postData = OrderHelper.makeCreateOrderDto(
    userId,
    qrData,
    qrCodeData,
    cartData,
    orderData,
    paymentData
  );
  const { token } = LoginService.getToken();
  if (paymentData && !_.isEmpty(paymentData)) {
    postData.payment_details = {
      details: JSON.stringify(paymentData),
      method: paymentData.method,
      processor_id: paymentData.processor_id
    };
    postData.payment_status_id = paymentData.payment_status_id;
  } else {
    let paymentStatuses = await PaymentService.getPaymentStatuses();
    let paidStatus = _.find(
      paymentStatuses,
      (paymentStatus) => paymentStatus.key === CONSTANTS.ORDERS.VARIABLES.PAYMENT_STATUSES.NOT_PAID
    );
    postData.payment_status_id = paidStatus.id;
  }
  postData.id = orderId;
  let url = `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.ORDERS.UPDATE(locationData.slug)}`;
  let createdOrder = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(postData),
    headers: { ...CONSTANTS.REQUEST_HEADERS, 'X-ACCESS-TOKEN': token }
  });
  createdOrder = await createdOrder.json();
  if (createdOrder) return createdOrder;
  throw new Error('Could not create order');
}


async function updateOrderPayment(locId, data) {
  const { token } = LoginService.getToken();
  let order = await fetch(`${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.ORDERS.UPDATEPAYMENT(locId)}`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: { ...CONSTANTS.REQUEST_HEADERS, 'X-ACCESS-TOKEN': token }
  });
  order = await order.json();
  if (order) return order;

  throw new Error('Could not update status of order');
}

async function settleBill(userId, orderIds) {
  const { token } = LoginService.getToken();
  let postData = { order_id: orderIds, user_id: userId };
  let orders = await fetch(`${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.ORDERS.SETTLE}`, {
    method: 'POST',
    body: JSON.stringify(postData),
    headers: { ...CONSTANTS.REQUEST_HEADERS, 'X-ACCESS-TOKEN': token }
  });
  if (orders && parseInt(orders.status) === 200) return orders;

  throw new Error('Could not create order');
}

async function getOrders(userId, locationId) {
  let postData = { user_id: userId };
  if (locationId) postData.location_id = locationId;
  let orders = await fetch(`${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.ORDERS.STATUS}`, {
    method: 'POST',
    body: JSON.stringify(postData),
    headers: { ...CONSTANTS.REQUEST_HEADERS }
  });
  orders = await orders.json();
  if (orders && parseInt(orders.status) === 200) return orders;
  //throw new Error('Could not get orders');
}

async function getOrder(userId, locationId, orderId) {
  let postData = { customer_id: userId, order_id: orderId };
  if (locationId) postData.location_id = locationId;
  let order = await fetch(`${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.ORDERS.ORDER}`, {
    method: 'POST',
    body: JSON.stringify(postData),
    headers: { ...CONSTANTS.REQUEST_HEADERS }
  });
  order = await order.json();
  return order;
  //throw new Error('Could not get orders');
}

async function getMyOrders(userId, locationId) {
  let orders = await fetch(
    `${CONSTANTS.NODE_API_URL}user/${userId}/${locationId}/${CONSTANTS.URLS.ORDERS.ORDERS}`,
    {
      method: 'POST'
    }
  );
  orders = await orders.json();
  if (orders) return orders;
  throw new Error('Could not get orders');
}

function billRequestOrders(orders, orderTypes) {
  return _.filter(orders, (order) => {
    return (
      !OrderHelper.isPlaced(order?.Status) &&
      !OrderHelper.isSeen(order?.Status) &&
      !OrderHelper.isCompleted(order?.Status) &&
      !OrderHelper.isCancelled(order?.Status) &&
      OrderTypeHelper.isDineIn(orderTypes, order?.Order?.order_type_id) &&
      PaymentHelper.isNotPaid(order?.PaymentStatus)
    );
  });
}

function currentTotalOrders(orders) {
  return _.filter(orders, (order) => {
    let statusId = parseInt(order.Order.status_id);
    return PaymentHelper.isNotPaid(order.PaymentStatus) && statusId !== 19; // Not paid and not cancelled
  });
}
async function getPOSOrder(loc_id, order_id) {
  const token = LoginService.getToken();
  let headers = { ...CONSTANTS.REQUEST_HEADERS };
  if (token) {
    headers['x-access-token'] = token.token;
    const url = `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.ORDERS.GETORDER(loc_id, order_id)}`;


    let order = await fetch(url, {
      method: 'GET',
      headers: headers
    });
    order = await order.json();
    if (order) { return order } else { return null; };
  }
}
